import React from 'react';
import BaseModal from "./BaseModal";
import {useTranslation} from "react-i18next";

function FinishModal({room, userId, currency}) {
    const {t} = useTranslation();
    const renderText = () => {
        if (room.isViewRoom) {
            return <h2>{t("modals.finish.game_end")}</h2>
        }
        return room.modal.msg ?
            <h2>{room.modal.winnerId === userId ? t(`modals.finish.win_${room?.modal?.msg}`) : t(`modals.finish.lose_${room?.modal?.msg}`)}</h2>
            :
            <h2>{room.modal.winnerId === userId ? t("modals.finish.you_won") : t("modals.finish.opponent_won")}</h2>
    }

    return (
        <BaseModal>
            <div className="modal__finish">
                {renderText()}
                <div className="modal__finish--content">
                    <p className="modal__finish--result">
                        {t("modals.finish.game_score")}
                        {room?.modal?.points &&
                            <span>{`${room?.modal?.points[room.modal.winnerId]} : ${room?.modal?.points[room.modal.loserId]}`}</span>}
                    </p>

                    {
                         <p className={"modal__finish--prize"}>
                            {t("modals.finish.amount")}
                            <span className="modal__finish--prize--amount">
                                {room?.modal?.winAmount?.[currency]}
                                <span className='currency-small'> {currency}</span>
                            </span>

                        </p>
                    }
                </div>
            </div>
        </BaseModal>
    )
}

export default FinishModal
